export default {
    template: [
        'RESOURCE_TEMPLATE',
        data => ({
            id: data.id,
            name: data.file_name,
            isFolder: !Boolean(data.download_url),
            thumbnail: data.thumbnail,
            description: data.description,
            parent: data.parent,
            downloadUrl: data.download_url,
            createdAt: data.created_at,
            updatedAt: data.updated_at,
            organizations: data.organizations,
            public: data.public,
        }),
    ],
    authorize: true,

    '/nodes': { GET: {} },
};
